import Player from '@vimeo/player'
import UI from '../stores/UI'

class Vimeo extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      muted: true
    }

    this.player = null
  }

  componentDidMount() {
    if (UI.isTouch) {
      this.initTouchPlayer()
    } else {
      this.initPlayer()
    }
  }

  initPlayer() {

    this.player = new Player(this.refs.el, {
      url: this.props.url,
      background: 1
    })

    this.player.ready().then(() => {
      this.player.setVolume(0)
      this.player.play()
    }).catch((err) => {
      console.log(err)
    })

  }

  initTouchPlayer() {
    this.player = new Player(this.refs.el, {
      url: this.props.url
    })
  }

  handleClick = e => {
    e.stopPropagation()

    if (UI.isTouch) {
      this.player.play()
    } else {
      this.mute()
    }
  }

  mute() {
    this.player.setVolume(this.state.muted ? 1 : 0)
    this.setState((prevState) => {
      return {
        muted: !prevState.muted
      }
    })
  }

  render() {

    return (
      <div className="fs center">
        <div className="rel inlb vimeo" onClick={this.handleClick} onMouseEnter={this.props.enterVideo} onMouseLeave={this.props.leaveVideo}>
          <div style={{ paddingTop: '56.6%' }} />
          <div className="pabs fs" ref="el" />
          {!UI.isTouch ? <div className="pabs fs" /> : null}
          {this.state.muted && !UI.isTouch ? (
            <div className="txt-c padx2" style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              transform: `translateY(100%)`
            }}>click to listen</div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default Vimeo



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Vimeo.js